import { FC } from 'react';
import { AllieText } from '../../../components';
import { StopTypeAssignButton, StopTypeButtonsRow } from './AssignReasonForm.styles';
import { StopTypes } from './AssignReasons.enum';

interface StopTypeChipsRowProps {
  selectedType: StopTypes;
  onTypeChange: (type: StopTypes) => void;
  labels: {
    all: string;
    planned: string;
    unplanned: string;
  };
}

export const StopTypeChipsRow: FC<StopTypeChipsRowProps> = ({
  selectedType,
  onTypeChange,
  labels,
}) => {
  const chips = [
    { type: StopTypes.all, label: labels.all },
    { type: StopTypes.unplanned, label: labels.unplanned },
    { type: StopTypes.planned, label: labels.planned },
  ];

  return (
    <StopTypeButtonsRow>
      {chips.map((chip) => (
        <StopTypeAssignButton
          key={chip.type}
          allieSize="small"
          corner="rounded"
          isSelected={selectedType === chip.type}
          allieType={selectedType === chip.type ? 'primary' : 'secondary'}
          onclick={() => onTypeChange(chip.type)}
        >
          <AllieText
            color={selectedType === chip.type ? 'white' : 'neutral-90'}
            weight={500}
          >
            {chip.label}
          </AllieText>
        </StopTypeAssignButton>
      ))}
    </StopTypeButtonsRow>
  );
};
